import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play-forward-sharp",
  "use": "icon-play-forward-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-play-forward-sharp\"><title>Play Forward</title><path d=\"M16 400l240-144L16 112v288zM256 400l240-144-240-144v288z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol